import { LOOKUP_PERSISTENCE_META } from '@/types/react-query-meta'

/** Long-lived metadata; collaborative option lists use optionQueryPreset. */
export const staticQueryPreset = {
  staleTime: 1000 * 60 * 60 * 24, // 24h
  gcTime: 1000 * 60 * 60 * 24, // 24h
  refetchOnWindowFocus: false,
  refetchOnMount: false,
  refetchOnReconnect: false,
  meta: LOOKUP_PERSISTENCE_META,
} as const

/** Collaborative options must recover after navigation and changes in another tab. */
export const optionQueryPreset = {
  staleTime: 1000 * 30,
  gcTime: staticQueryPreset.gcTime,
  refetchOnWindowFocus: 'always',
  refetchOnMount: true,
  refetchOnReconnect: true,
  meta: LOOKUP_PERSISTENCE_META,
} as const

/** Reference/lookup data that changes infrequently (references, places, projects). */
export const referenceQueryPreset = {
  staleTime: 1000 * 60 * 5, // 5 min
  gcTime: 1000 * 60 * 60, // 1h
  refetchOnWindowFocus: false,
  meta: LOOKUP_PERSISTENCE_META,
} as const

/** Transactional data that can change often (orders, dashboard). */
export const transactionalQueryPreset = {
  staleTime: 1000 * 60, // 1 min
  gcTime: 1000 * 60 * 10, // 10 min
  refetchOnWindowFocus: true,
  refetchOnMount: false,
  refetchOnReconnect: false,
} as const

/** Grid view data needs freshness across tabs while keeping the last valid list during refetch. */
export const gridViewQueryPreset = {
  staleTime: 1000 * 30,
  gcTime: 1000 * 60 * 30,
  refetchOnWindowFocus: true,
  refetchOnMount: true,
  refetchOnReconnect: true,
  meta: LOOKUP_PERSISTENCE_META,
} as const

/** Mutable CAS preference snapshots must never be restored as lookup data. */
export const gridViewPreferenceQueryPreset = {
  staleTime: 0,
  gcTime: 1000 * 60 * 30,
  refetchOnWindowFocus: true,
  refetchOnMount: 'always' as const,
  refetchOnReconnect: true,
} as const
